'use client';

import { useEffect } from 'react';

export const CAL_LINK = process.env.NEXT_PUBLIC_CAL_LINK ?? '';
// Namespace = last path segment: "agathos-technology/discovery" → "discovery"
const CAL_NS = CAL_LINK ? (CAL_LINK.split('/').pop() ?? 'booking') : 'booking';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Cal?: any;
  }
}

export function useCalEmbed() {
  useEffect(() => {
    if (!CAL_LINK || window.Cal) return;

    // Official Cal.com embed IIFE — must replicate exactly so embed.js finds cal.ns
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (function (C: any, A: string, L: string) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const p = (a: any, ar: any) => a.q.push(ar);
      const d = C.document;
      C.Cal = C.Cal || function () {
        const cal = C.Cal;
        // eslint-disable-next-line prefer-rest-params
        const ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          const s = d.createElement('script');
          s.src = A;
          s.async = true;
          d.head.appendChild(s);
          cal.loaded = true;
        }
        if (ar[0] === L) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any, prefer-rest-params
          const api: any = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, [L, api]);
          } else {
            p(cal, ar);
          }
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');

    window.Cal('init', CAL_NS, { origin: 'https://cal.com' });
    window.Cal.ns[CAL_NS]('ui', {
      theme: 'light',
      styles: { branding: { brandColor: '#0A4492' } },
      hideEventTypeDetails: false,
      layout: 'month_view',
    });
  }, []);
}

interface CalButtonProps {
  label: string;
  className?: string;
}

export function CalButton({ label, className = '' }: CalButtonProps) {
  useCalEmbed();

  if (!CAL_LINK) return null;

  return (
    <button
      data-cal-namespace={CAL_NS}
      data-cal-link={CAL_LINK}
      data-cal-config='{"layout":"month_view"}'
      className={className}
    >
      {label}
    </button>
  );
}
